import type { IRatingMatrixFrameworkParameter } from '__generated__';
import {
  baseApi,
  parameterListTag,
  subParameterListTag,
  templateDetailTag,
} from 'store/api';
import { API, asPatchBody, normalizeError } from 'utils/api-client';
import type { TreeSortDiff } from './types';
import { ratingMatrixFrameworkParameterApi } from '../rating-matrix-framework-parameter/api';

export const ratingMatrixFrameworkTreeApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    applyTreeSortChanges: builder.mutation<
      void,
      {
        frameworkTemplateID: number;
        diff: TreeSortDiff;
        optimisticParameters: IRatingMatrixFrameworkParameter[];
      }
    >({
      async queryFn({ diff }) {
        try {
          await Promise.all([
            ...diff.parameterPatches.map(({ id, patch }) =>
              API.api.ratingMatrixFrameworkParameterPatchPartialUpdate(
                { id },
                asPatchBody(patch),
              ),
            ),
            ...diff.subParameterPatches.map(({ id, patch }) =>
              API.api.ratingMatrixFrameworkSubParameterPatchPartialUpdate(
                { id },
                asPatchBody(patch),
              ),
            ),
          ]);

          return { data: undefined };
        } catch (error) {
          return { error: normalizeError(error) };
        }
      },
      invalidatesTags: (_result, _error, arg) => [
        parameterListTag(arg.frameworkTemplateID),
        subParameterListTag(arg.frameworkTemplateID),
        templateDetailTag(arg.frameworkTemplateID),
      ],
      async onQueryStarted(
        { frameworkTemplateID, optimisticParameters },
        { dispatch, queryFulfilled },
      ) {
        const patchResult = dispatch(
          ratingMatrixFrameworkParameterApi.util.updateQueryData(
            'getParametersTree',
            { frameworkTemplateID },
            () => optimisticParameters,
          ),
        );

        try {
          await queryFulfilled;
        } catch {
          patchResult.undo();
        }
      },
    }),
  }),
});

export const { useApplyTreeSortChangesMutation } = ratingMatrixFrameworkTreeApi;
